export const CONTRIBUTOR_LOGIN_REQUEST = 'CONTRIBUTOR_LOGIN_REQUEST';
export const CONTRIBUTOR_LOGIN_SUCCESS = 'CONTRIBUTOR_LOGIN_SUCCESS';
export const CONTRIBUTOR_LOGIN_FAIL = 'CONTRIBUTOR_LOGIN_FAIL';
export const CONTRIBUTOR_LOGOUT = 'CONTRIBUTOR_LOGOUT';
export const CONTRIBUTOR_REGISTER_REQUEST = 'CONTRIBUTOR_REGISTER_REQUEST';
export const CONTRIBUTOR_REGISTER_SUCCESS = 'CONTRIBUTOR_REGISTER_SUCCESS';
export const CONTRIBUTOR_REGISTER_FAIL = 'CONTRIBUTOR_REGISTER_FAIL';
export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAIL = 'FORGOT_PASSWORD_FAIL';
export const SEND_RESET_PASSWORD_REQUEST = 'SEND_RESET_PASSWORD_REQUEST';
export const SEND_RESET_PASSWORD_SUCCESS = 'SEND_RESET_PASSWORD_SUCCESS';
export const SEND_RESET_PASSWORD_FAIL = 'SEND_RESET_PASSWORD_FAIL';
export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAIL = 'RESET_PASSWORD_FAIL';
export const CREATE_PROFILE_REQUEST = 'CREATE_PROFILE_REQUEST';
export const CREATE_PROFILE_SUCCESS = 'CREATE_PROFILE_SUCCESS';
export const CREATE_PROFILE_FAIL = 'CREATE_PROFILE_FAIL';
export const GET_USER_PROFILE_REQUEST = 'GET_USER_PROFILE_REQUEST';
export const GET_USER_PROFILE_SUCCESS = 'GET_USER_PROFILE_SUCCESS';
export const GET_USER_PROFILE_FAIL = 'GET_USER_PROFILE_FAIL';
export const CONTRIBUTOR_ROLES_REQUEST = 'CONTRIBUTOR_ROLES_REQUEST';
export const CONTRIBUTOR_ROLES_SUCCESS = 'CONTRIBUTOR_ROLES_SUCCESS';
export const CONTRIBUTOR_ROLES_FAIL = 'CONTRIBUTOR_ROLES_FAIL';